<script>
export default {
    data() {
        return {
            exportTypes: [
                {
                    value: 'link_checkin',
                    text: this.getI18n('EXPORT_PRESENTATION_JOBS', 'TYPES.link'),
                },
                {
                    value: 'ppt_checkin',
                    text: this.getI18n('EXPORT_PRESENTATION_JOBS', 'TYPES.ppt'),
                },
            ],
            exportOrders: [
                {
                    value: 'point_of_sale',
                    text: this.getI18n('EXPORT_PRESENTATION_JOBS', 'TITLES.pos_alias'),
                },
                {
                    value: 'user',
                    text: this.getI18n('USERS', 'TITLES.user'),
                },
            ],
        }
    },
}
</script>
